/**
 * Page Common
 */
const scrollLockedClass = 'u-scroll-locked';

/**
 * lock document scrolling
 */
function scrollLocked() {
  $('html, body').addClass(scrollLockedClass);
}

/**
 * unlock document scrolling
 */
function scrollUnlocked() {
  $('html, body').removeClass(scrollLockedClass);
}

/**
 * is document scroll-lock
 */
function isScrollLocked() {
  return ($('html').hasClass(scrollLockedClass) && $('body').hasClass(scrollLockedClass));
}

export {
  scrollLocked,
  scrollUnlocked,
  isScrollLocked,
};



// WEBPACK FOOTER //
// ./js/common/template/page.js